import SoIndex from "@/components/flux_oms/so/SoIndex.vue";
import SoUpload from "@/components/flux_oms/so/SoUpload.vue";
import SoCreate from "@/components/flux_oms/so/SoCreate.vue";
import SoDetail from "@/components/flux_oms/so/SoDetail.vue";
import SoUpdate from "@/components/flux_oms/so/SoUpdate.vue";

let routesSo= [
    {
        path: '',
        meta: {
            title: "SO (Outbound)",
        },
        name: "SoIndex",
        component: SoIndex
    },
    {
        path: 'create',
        meta: {
          title: "SO (Outbound) Create",
        },
        name: "SoCreate",
        component: SoCreate
    },

    {
        path: 'upload',
        meta: {
          title: "SO (Outbound)",
        },
        name: "SoUploads",
        component: SoUpload
    },

    {
        path: 'detail/:id',
        meta: {
          title: "SO (Outbound) Detail",
        },
        name: "SoDetail",
        component: SoDetail
    },


    {
      path: 'edit/:id',
      meta: {
        title: "SO (Outbound) Update",
      },
      name: "SoUpdate",
      component: SoUpdate
  },
     
   
     
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Master SKU Edit",
    //     },
    //     name: "MasterSKUEdit",
    //     component: MasterSKUEdit
    // },
    
]

export default routesSo
  